/*
  Custom related products behavior for sections/custom-related.liquid.
  Owns the related-products custom element for the custom product page section,
  using the same selectors and theme events as assets/related-products.js while
  allowing the recently-viewed block to be absent. Safe to load more than once.
*/
(function () {
  'use strict';

  const selectors = {
    apiTemplate: '[data-api-related-template]',
    productItem: '.product-item',
    gridItem: '[data-grid-item]',
    relatedSection: '[data-related-section]',
    recentlyViewed: 'recently-viewed',
    gridSlider: 'grid-slider',
    recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
  };

  const attributes = {
    limit: 'data-limit',
    productId: 'data-product-id',
    layout: 'data-layout',
  };

  const classes = {
    hidden: 'hidden',
    mobileSlider: 'grid--mobile-slider',
    slider: 'grid--slider',
  };

  if (customElements.get('related-products')) {
    return;
  }

  customElements.define(
    'related-products',
    class CustomRelatedProducts extends HTMLElement {
      constructor() {
        super();
        this.relatedItems = 0;
        this.wrapper = this.querySelector(selectors.recentlyViewedWrapper);
        this.recentlyViewed = this.querySelector(selectors.recentlyViewed);
      }

      connectedCallback() {
        this.loadRelatedProducts();
        this.loadRecentlyViewedProducts();
      }

      loadRelatedProducts() {
        const relatedSection = this.querySelector(selectors.relatedSection);

        if (!relatedSection) {
          return;
        }

        const productId = relatedSection.getAttribute(attributes.productId);
        const limit = relatedSection.getAttribute(attributes.limit);
        const url = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${limit}&product_id=${productId}&intent=related`;

        fetch(url)
          .then((response) => response.text())
          .then((text) => this.handleRelatedProductsResponse(text, relatedSection))
          .catch(() => this.hideSection(relatedSection));
      }

      handleRelatedProductsResponse(text, relatedSection) {
        const holder = document.createElement('div');
        const template = new DOMParser().parseFromString(text, 'text/html').querySelector(selectors.apiTemplate);

        if (!template) {
          this.hideSection(relatedSection);
          this.updateVisibility();
          return;
        }

        holder.innerHTML = template.innerHTML;
        const productCount = holder.querySelectorAll(selectors.gridItem).length;

        if (productCount > 0) {
          relatedSection.innerHTML = holder.innerHTML;
          this.relatedItems = productCount;

          const columnsMobile = parseInt(relatedSection.style.getPropertyValue('--COLUMNS-MOBILE'), 10);
          const firstItem = relatedSection.querySelector(selectors.gridItem);

          if (firstItem) {
            if (columnsMobile === 0) {
              firstItem.parentElement.classList.add(classes.mobileSlider);
            }

            if (relatedSection.getAttribute(attributes.layout) === 'slider') {
              firstItem.parentElement.classList.add(classes.slider);
            } else {
              firstItem.parentElement.classList.remove(classes.slider);
            }
          }
        } else {
          this.hideSection(relatedSection);
        }

        this.updateVisibility();
      }

      loadRecentlyViewedProducts() {
        if (!this.recentlyViewed) {
          return;
        }

        this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
          this.handleRecentlyViewedResponse();
        });
      }

      handleRecentlyViewedResponse() {
        if (!this.recentlyViewed) {
          return;
        }

        const minimum = parseInt(this.recentlyViewed.dataset.minimum, 10) || 1;
        const items = this.recentlyViewed.querySelectorAll(selectors.productItem);
        const slider = this.recentlyViewed.querySelector(selectors.gridSlider);
        const hasRecentWithoutTabs = !this.wrapper && items.length > 0;
        const hasRecentTab = this.wrapper && items.length >= minimum;

        if (hasRecentWithoutTabs || hasRecentTab) {
          if (hasRecentTab) {
            this.wrapper.classList.remove(classes.hidden);
          }

          this.recentlyViewed.classList.remove(classes.hidden);
          this.recentlyViewed.dispatchEvent(new CustomEvent('theme:tab:check', { bubbles: true }));

          if (slider) {
            slider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
          }
        }

        this.updateVisibility();
      }

      hideSection(relatedSection) {
        relatedSection.dispatchEvent(new CustomEvent('theme:tab:hide', { bubbles: true }));
      }

      updateVisibility() {
        const config = Shopify.Products.getConfig();
        const hide = config.howManyToShow < 1 && this.relatedItems < 1;
        this.classList.toggle(classes.hidden, hide);
      }
    }
  );
})();
